import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ZenithModalVariant } from '../zenith/zenith.types';

@Component({
  selector: 'qpc-action-modal',
  imports: [TranslateModule, ZenithComponentsModule],
  template: `
    <zenith-modal
        [attr.zn-heading]="heading() | translate"
        [attr.zn-variant]="variant()"
        (znClose)="onCancel.emit()"
        zn-open>

      <zenith-modal-content>
        <ng-content></ng-content>
      </zenith-modal-content>

      <zenith-modal-footer>
        <zenith-button
          [attr.zn-disabled]="disabled()"
          (click)="onAction.emit()"
          zn-appearance="secondary"
          zn-type="button">{{ actionButtonLabel() | translate }}
        </zenith-button>
        <zenith-button
          [attr.zn-disabled]="disabled()"
          (click)="onCancel.emit()"
          zn-appearance="plain"
          zn-type="button">{{ cancelButtonLabel() | translate }}
        </zenith-button>
      </zenith-modal-footer>

    </zenith-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ActionModal {
  readonly heading = input.required<string>();
  readonly variant = input<ZenithModalVariant>('small');
  readonly actionButtonLabel = input<string>('components.zenith.action-modal.confirm');
  readonly cancelButtonLabel = input<string>('components.zenith.action-modal.cancel');
  readonly disabled = input<boolean>(false);

  readonly onAction = output();
  readonly onCancel = output();

}
